import { Model } from 'shared/services/api/models/Model'
import { LetterboxDocument } from 'shared/services/api/models/letterbox'
import { OrderBillingAddress } from './orderBillingAddress'
import { OrderCarrier } from './orderCarrier'
import { OrderDeliveryAddress } from './orderDeliveryAddress'
import { OrderDiscount } from './orderDiscount'
import { OrderDocuments } from './orderDocuments'
import { OrderPayment } from './orderPayment'
import {
  OrderDiscountV1,
  OrderDocumentsV1,
  SuborderV1
} from './ordersResponseTypes'

const SELLER_SHOP_APOTHEKE: string = 'shop-apotheke.com'

export class Suborder extends Model {
  public readonly billingAddress: OrderBillingAddress
  public readonly carrier: OrderCarrier
  public readonly deliveryAddress: OrderDeliveryAddress
  public readonly discounts: OrderDiscount[]
  public readonly isSellerShopApotheke: boolean
  public readonly documentsToDownload: LetterboxDocument[]
  public readonly orderDocuments: OrderDocuments[]
  public readonly orderType: string
  public readonly payment: OrderPayment
  public readonly seller: string
  public readonly sellerId: string
  public readonly sellerName: string
  public readonly shippedDate: string
  public readonly status: string
  public readonly subOrderId: string
  public readonly totalAmount: number
  public readonly totalAmountDocuments: number
  public readonly totalAmountPrescriptionBonus: number
  public readonly totalAmountRedpoints: number

  constructor(src: SuborderV1) {
    super(src)
    if (src.billingAddress) {
      this.billingAddress = new OrderBillingAddress(src.billingAddress)
    }
    if (src.carrier) {
      this.carrier = new OrderCarrier(src.carrier)
    }
    if (src.deliveryAddress) {
      this.deliveryAddress = new OrderDeliveryAddress(src.deliveryAddress)
    }
    this.discounts = Array.isArray(src.discounts)
      ? src.discounts.map(
          (discount: OrderDiscountV1) => new OrderDiscount(discount)
        )
      : []
    this.documentsToDownload = Array.isArray(src.documentsToDownload)
      ? src.documentsToDownload.map(document => new LetterboxDocument(document))
      : []
    this.orderDocuments = Array.isArray(src.orderDocuments)
      ? src.orderDocuments.map(
          (orderDocument: OrderDocumentsV1) => new OrderDocuments(orderDocument)
        )
      : []
    this.orderType = src.orderType
    if (src.payment) {
      this.payment = new OrderPayment(src.payment)
    }
    this.sellerId = src.sellerId
    this.sellerName = src.sellerName
    this.shippedDate = src.shippedDate
    // TO DO: remove when bully returns translation key instead of status:
    this.status = src.status.includes('account.orders.status')
      ? src.status
      : `account.orders.status.${src.status}`
    this.subOrderId = src.subOrderId
    this.totalAmount = src.totalAmount
    this.totalAmountDocuments = src.totalAmountDocuments
    this.totalAmountPrescriptionBonus = src.totalAmountPrescriptionBonus
    this.totalAmountRedpoints = src.totalAmountRedpoints

    this.isSellerShopApotheke =
      this.sellerId === SELLER_SHOP_APOTHEKE ||
      this.sellerName === SELLER_SHOP_APOTHEKE
    this.seller = this.sellerName
  }
}
